import { makeRequest } from '@humanspace/infrastructure';

// Spaces (reuse same backend endpoints — spaces are project-scoped)
export const getSpaces = async projectId =>
  makeRequest({ path: `/projects/${projectId}/spaces` });

export const createSpace = async (projectId, spaceData) =>
  makeRequest({
    path: `/projects/${projectId}/spaces`,
    method: 'POST',
    body: spaceData,
    json: true,
  });

export const updateSpace = async (spaceId, spaceData) =>
  makeRequest({
    path: `/spaces/${spaceId}`,
    method: 'PATCH',
    body: spaceData,
    json: true,
  });

export const deleteSpace = async spaceId =>
  makeRequest({
    path: `/spaces/${spaceId}`,
    method: 'DELETE',
  });

// Healthcare Assessments
export const saveAssessment = async (projectId, assessmentData) =>
  makeRequest({
    path: `/projects/${projectId}/brainhealth/assess`,
    method: 'POST',
    body: assessmentData,
  });

export const getAssessments = async projectId =>
  makeRequest({
    path: `/projects/${projectId}/brainhealth/assessments`,
  });

// HDPS Features (reuse BHPS endpoints — backend is agnostic)
export const getHdpsFeatures = async spaceId =>
  makeRequest({
    path: `/spaces/${spaceId}/bhpsfeatures`,
  });

export const updateHdpsFeatures = async (spaceId, features) =>
  makeRequest({
    path: `/spaces/${spaceId}/bhpsfeatures`,
    method: 'PUT',
    body: { features },
  });

// Population
export const getPopulation = async projectId =>
  makeRequest({
    path: `/projects/${projectId}/populations`,
  });

export const savePopulation = async (projectId, populationData) =>
  makeRequest({
    path: `/projects/${projectId}/populations`,
    method: 'POST',
    body: populationData,
  });

export const deletePopulation = async id =>
  makeRequest({
    path: `/populations/${id}`,
    method: 'DELETE',
  });

// Project Data (generic key-value store for brain health data)
export const getAllProjectData = async projectId =>
  makeRequest({ path: `/projects/${projectId}/data` });

export const putProjectData = async (projectId, key, value) =>
  makeRequest({
    path: `/projects/${projectId}/data/${key}`,
    method: 'PUT',
    body: { value },
    json: true,
  });

export const putProjectDataBatch = async (projectId, dataMap) => {
  const promises = Object.entries(dataMap).map(([key, value]) =>
    putProjectData(projectId, key, value).catch(() => null)
  );
  return Promise.allSettled(promises);
};
